import { getSrc } from 'gatsby-plugin-image';
import isEmpty from 'lodash/isEmpty';
import { getLogoPath } from '../../components/layout/utils/Logo';
import { graphql, useStaticQuery } from 'gatsby';

type ArticleData = {
  title: string;
  datePublished: string;
  dateModified: string;
  imageUrls: Array<string>;
  siteLogo: string;
  url: string;
  authors: any[];
};

export const convertArticleData = (data: any) => {
  let imageUrls = `${process.env.GATSBY_SITE_URL}${getSrc(data.relationships.field_featured_image?.localFile)}`;
  // Fallback static image if no featured image on article
  if (isEmpty(data.relationships.field_featured_image?.localFile)) {
    const data = useStaticQuery(graphql`
      query {
        article_placeholder: file(relativePath: { eq: "global/placeholder/featured/article.png" }) {
          childImageSharp {
            ...HeroImage
          }
        }
      }
    `);
    imageUrls = `${process.env.GATSBY_SITE_URL}${getSrc(data.article_placeholder)}`;
  }

  return {
    title: data.title,
    datePublished: data.created,
    dateModified: data.changed,
    imageUrls: imageUrls && [imageUrls],
    siteLogo: data.siteMetadata.logo,
    url: process.env.GATSBY_SITE_URL + data.path.alias,
    authors: data.relationships.field_contributor
  } as ArticleData;
};

const articleStructuredData = (data: ArticleData | null) => {
  if (isEmpty(data)) {
    return null;
  }
  const logo = process.env.GATSBY_SITE_URL + '/' + getLogoPath(process.env.GATSBY_SITE_NAME ?? '', data.siteLogo);
  const authors = !isEmpty(data.authors)
    ? data.authors.map((author) => {
        return {
          '@type': 'Person',
          name: `${author.firstName} ${author.lastName}`,
          jobTitle: author?.filed_job_title,
          url: `${process.env.GATSBY_SITE_URL}${author?.path?.alias}`
        };
      })
    : { '@type': 'Organization', name: process.env.GATSBY_SITE_NAME, url: process.env.GATSBY_SITE_URL + '/editors' };

  const structuredData: any = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': data.url
    },
    headline: data.title,
    image: data.imageUrls,
    datePublished: data.datePublished,
    dateModified: data.dateModified,
    publisher: {
      '@type': 'Organization',
      name: process.env.GATSBY_SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: logo
      }
    },
    author: authors
  };
  return JSON.stringify(structuredData);
};

export default articleStructuredData;
